import ApplicationListWithCreate from './ApplicationListWithCreate'

export default ApplicationListWithCreate
